import { useCallback, useEffect, useMemo, useState } from "react";
import { Table, Spin, Empty } from "antd";
import { useLocation } from "react-router";
import commonApi from "../../../../apis/commonApi";
import FeedbackForm from "../feedbackForm";
import { formatFeedbackParam } from "../../../../utils";
import "./index.scss";

const defaultSize = 8;

const FeedbackList = () => {
  const { search } = useLocation();
  const [curPage, setCurPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [detailInfo, setDetailInfo] = useState();
  const [showDetail, setShowDetail] = useState(false);
  const [urlInfo, setUrlInfo] = useState({
    sys: "CRM",
  });

  const getList = useCallback((page, sys, userCode) => {
    commonApi
      .getFeedbackList({
        feedbackSys: sys,
        submitUserCode: userCode,
        size: defaultSize,
        page,
      })
      .then((res) => {
        if (res && res.records) {
          setList(res.records);
          setTotal(res.total);
        } else {
          setList([]);
          setTotal(0);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    const query = new URLSearchParams(search);
    const codeInfo = query.get("code");
    const _urlInfo = formatFeedbackParam(codeInfo);
    setUrlInfo(_urlInfo);
    if (_urlInfo && _urlInfo.userCode) {
      getList(1, _urlInfo.sys, _urlInfo.userCode);
    }
  }, [getList, search]);

  const goDetail = useCallback((id) => {
    setLoading(true);
    commonApi
      .getFeedbackDetails(id)
      .then((res) => {
        // console.log("res==", res);
        if (res) {
          setDetailInfo(res);
          setShowDetail(true);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const columns = useMemo(
    () => [
      {
        title: "提交人工号",
        dataIndex: "submitUserCode",
        key: "submitUserCode",
      },
      {
        title: "提交人姓名",
        dataIndex: "submitUserName",
        key: "submitUserName",
      },
      {
        title: "提交时间",
        dataIndex: "submitDate",
        key: "submitDate",
      },
      {
        title: "反馈模块",
        dataIndex: "feedbackTypeName",
        key: "feedbackTypeName",
      },
      {
        title: "操作",
        key: "action",
        render: (_, record) => (
          <span
            style={{ color: "#004098", cursor: "pointer" }}
            onClick={() => goDetail(record.id)}
          >
            查看
          </span>
        ),
      },
    ],
    [goDetail]
  );

  const onChangeTabPage = (page) => {
    setCurPage(page);
    getList(page, urlInfo.sys, urlInfo.userCode);
  };

  return (
    <div className="feedback-list-wrapper">
      <Spin spinning={loading}>
        <Table
          className={`list-table ${showDetail ? "hide" : ""}`}
          dataSource={list}
          columns={columns}
          pagination={{
            position: "bottom",
            current: curPage,
            pageSize: defaultSize,
            total: total,
            onChange: onChangeTabPage,
            showTotal: (total, range) => `共 ${total} 条`,
          }}
          locale={{
            emptyText: (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description="暂无数据"
              ></Empty>
            ),
          }}
        />
      </Spin>
      {showDetail ? (
        <FeedbackForm
          detailInfo={detailInfo}
          isView={true}
          setShowDetail={setShowDetail}
        />
      ) : null}
    </div>
  );
};

export default FeedbackList;
